export const RP_RESERVATION_TEST_IDS = {
    // Entry points
    CTA_SIDEBAR: "rp-reservation-cta-sidebar",
    CTA_CONTACT_BAR: "rp-reservation-cta-contact-bar",
    CTA_RESERVED: "rp-reservation-cta-reserved",
    CTA_PLACEHOLDER: "rp-reservation-cta-placeholder",
    CONTACT_BAR_INFO: "rp-reservation-contact-bar-info",
    POST_LEAD_RESERVATION_BUTTON: "rp-reservation-post-lead-button",
    UNLOCK_CHOICE_RESERVATION_OPTION: "rp-reservation-unlock-choice-option",

    // Code step
    CODE_STEP: "rp-reservation-code-step",
    GET_CODE_INPUT: (index: number) => `rp-reservation-code-input-${index}`,
    CODE_ERROR: "rp-reservation-code-error",
    RESEND_BUTTON: "rp-reservation-resend-button",
    RESEND_COOLDOWN: "rp-reservation-resend-cooldown",
    RESEND_EXHAUSTED: "rp-reservation-resend-exhausted",
    LOADER: "rp-reservation-loader",
    BACK_BUTTON: "rp-reservation-back-button",
    CLOSE_BUTTON: "rp-reservation-close-button",
    ERROR_NOTICE: "rp-reservation-error-notice",
    RETRY_BUTTON: "rp-reservation-retry-button",
    ERROR_CLOSE_BUTTON: "rp-reservation-error-close-button",

    // Name step - the profile name the reservation was rejected for
    NAME_STEP: "rp-reservation-name-step",
    NAME_INPUT: "rp-reservation-name-input",
    NAME_SUBMIT_BUTTON: "rp-reservation-name-submit-button",
    NAME_ERROR: "rp-reservation-name-error",

    // Confirmation
    CONFIRMED_STEP: "rp-reservation-confirmed-step",
    CONFIRMED_CLOSE_BUTTON: "rp-reservation-confirmed-close-button"
} as const;
export const RP_RESERVATION_TEST_IDS = {
    // Entry points
    CTA_SIDEBAR: "rp-reservation-cta-sidebar",
    CTA_CONTACT_BAR: "rp-reservation-cta-contact-bar",
    CTA_RESERVED: "rp-reservation-cta-reserved",
    CTA_PLACEHOLDER: "rp-reservation-cta-placeholder",
    CONTACT_BAR_INFO: "rp-reservation-contact-bar-info",
    POST_LEAD_RESERVATION_BUTTON: "rp-reservation-post-lead-button",
    UNLOCK_CHOICE_RESERVATION_OPTION: "rp-reservation-unlock-choice-option",

    // Code step
    CODE_STEP: "rp-reservation-code-step",
    GET_CODE_INPUT: (index: number) => `rp-reservation-code-input-${index}`,
    CODE_ERROR: "rp-reservation-code-error",
    RESEND_BUTTON: "rp-reservation-resend-button",
    RESEND_COOLDOWN: "rp-reservation-resend-cooldown",
    RESEND_EXHAUSTED: "rp-reservation-resend-exhausted",
    LOADER: "rp-reservation-loader",
    BACK_BUTTON: "rp-reservation-back-button",
    CLOSE_BUTTON: "rp-reservation-close-button",
    ERROR_NOTICE: "rp-reservation-error-notice",
    RETRY_BUTTON: "rp-reservation-retry-button",
    ERROR_CLOSE_BUTTON: "rp-reservation-error-close-button",

    // Name step - the profile name the reservation was rejected for
    NAME_STEP: "rp-reservation-name-step",
    NAME_INPUT: "rp-reservation-name-input",
    NAME_SUBMIT_BUTTON: "rp-reservation-name-submit-button",
    NAME_ERROR: "rp-reservation-name-error",

    // Confirmation
    CONFIRMED_STEP: "rp-reservation-confirmed-step",
    CONFIRMED_CLOSE_BUTTON: "rp-reservation-confirmed-close-button"
} as const;
